import { DateTime } from 'luxon';

export const isMockBackend = import.meta.env?.VITE_IS_MOCK_BACKEND === 'true';

export const isMockAdobeAnlitycs = import.meta.env?.VITE_IS_MOCK_ADOBE_ANALITYCS === 'true';

export const chickenPieces = [
  'Alas',
  'Contramuslo',
  'Entremuslo',
  'Pechuga',
  'Pernil',
  'Pierna',
  'Pollo entero',
];

export const processStages = ['Granja', 'Planta', 'Distribución', 'Frescura'];

// input: 'mm/dd/yyyy'
// otuput 'dd/mm/yyyy'
export const formatShortDate = (date) => {
  const original = DateTime.fromISO(date);
  const formated = original.toFormat('dd/MM/yyyy');
  return formated;
};

// input: '01/01/2025' mm/dd/yyy
// input: 4
// otuput '04/01/2025' dd/mm/yyyy
export const addDays = (date, days) => {
  const original = DateTime.fromISO(date);
  const newDate = original.plus({ days: days });
  const formated = newDate.toFormat('dd/MM/yyyy');
  return formated;
};

// input date1 = '20/03/2025' - date2 = '23/03/2025'
// output 2
export const daysBetweenDates = (date1, date2) => {
  const dateTime1 = DateTime.fromFormat(date1, 'dd/MM/yyyy');
  const dateTime2 = DateTime.fromFormat(date2, 'dd/MM/yyyy');
  const days = Math.abs(dateTime1.diff(dateTime2, 'days').days);
  return days > 0 ? days : 1;
};

// responsive fixed sizes for detailed view elements
const panelMaxHeight = 63;
const panelMaxHeightSX = 58;
const panelMinHeight = 20;
const panelMinHeightXS = 25;
const panelLandscapeMaxHeight = 70;
const panelLandscapeMinHeight = 40;
const panelLandscapeMinHeightXS = 44;
const panelLandscapeMaxHeightXS = 65;

export const getPanelMinHeigth = (isLandscape, isXS) => {
  if (isLandscape) {
    return isXS ? panelLandscapeMinHeightXS : panelLandscapeMinHeight;
  }
  return isXS ? panelMinHeightXS : panelMinHeight;
};

export const getPanelMaxHeigth = (isLandscape, isXS) => {
  if (isLandscape) {
    return isXS ? panelLandscapeMaxHeightXS : panelLandscapeMaxHeight;
  }
  return isXS ? panelMaxHeightSX : panelMaxHeight;
};
